import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBetalen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      d="M36 12H4v16h32z"
    />
    <path
      fill="#B3E9B1"
      d="M20 25a5 5 0 1 0 0-10 5 5 0 0 0 0 10"
    />
    <path
      fill="#00215B"
      d="M33.5 29H7v1h27.5v-9.5h-1z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBetalen);

export default ForwardRef;
